import * as actionTypes from './actionTypes';
import { jobService } from './services';
import { fetchValidateAccess } from '@app/src/common/session';

const fetchJobRequest = () => ({
  type: actionTypes.FETCH_JOB_REQUEST
});

const fetchJobSuccess = (data) => ({
  type: actionTypes.FETCH_JOB_SUCCESS,
  data
});

const fetchJobFailure = () => ({
  type: actionTypes.FETCH_JOB_FAILURE
});

const setJobMessage = (message?: string) => ({
  type: actionTypes.SET_JOB_MESSAGE,
  message
});

export const clearJobMessage = () => ({
  type: actionTypes.CLEAR_JOB_MESSAGE
});

export const clearJobData = () => ({
  type: actionTypes.CLEAR_JOB_DATA
});

export const setJobSelected = (selected: string) => ({
  type: actionTypes.SET_JOB_SELECTED,
  selected
});

export const setJobWordFound = (word: string) => ({
  type: actionTypes.SET_JOB_WORD_FOUND,
  word
});

export const clearJobSelected = () => ({
  type: actionTypes.CLEAR_JOB_SELECTED
});

export const fetchJob = (job: string): Function => {
  return async dispatch => {
    dispatch(fetchJobRequest());
    await dispatch(fetchValidateAccess());
    try {
      const data = await jobService.get(job);
      dispatch(fetchJobSuccess(data));
      dispatch(setJobWordFound(job));
      dispatch(setJobMessage(data && data.length === 0 && 'No se encontraron resultados.'))
    } catch (e) {
      dispatch(fetchJobFailure());
    }
  }
};
